import { defineFetcher } from "~/api/_common/defineFetcher"
import { DELETE } from "~/api/_common/http"

import { BooleanLike } from "../_common/types"
import { FavoriteBody } from "./_types"

const PATH = "/favorite"

export type DeleteFavorite = BooleanLike

export const fetchDeleteFavorite = defineFetcher((body: FavoriteBody): Promise<DeleteFavorite> => {
  return DELETE(PATH, body)
})
